import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import SecondaryButton from "components/Global/Buttons/SecondaryButton";
import { downloadCapTemplate } from "store/state/cashflows";

const DownloadCapTemplate = props => (
  <SecondaryButton onClick={() => props.downloadCapTemplate({ hedgeId: props.hedgeId })}>Cap Template</SecondaryButton>
);

export default connect(null, {
  downloadCapTemplate
})
(DownloadCapTemplate);
